import { render, staticRenderFns } from "./courseAndLessonDetailNav.vue?vue&type=template&id=491c2494"
import script from "./courseAndLessonDetailNav.vue?vue&type=script&lang=js"
export * from "./courseAndLessonDetailNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports